'use client';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface SavedTrip {
  id: string;
  title: string;
  destination: string;
  image: string;
  alt: string;
  estimatedPrice: number;
  duration: string;
  savedDate: string;
}

const SavedTrips = () => {
  const mockSavedTrips: SavedTrip[] = [
  {
    id: 'ST001',
    title: 'Tokyo Cherry Blossom Experience',
    destination: 'Tokyo, Japan',
    image: "https://images.unsplash.com/photo-1724837962088-7deca2f3f872",
    alt: 'Tokyo cityscape with cherry blossom trees in full bloom and Mount Fuji in background',
    estimatedPrice: 3499,
    duration: '10 Days',
    savedDate: '2024-02-10'
  },
  {
    id: 'ST002',
    title: 'Swiss Alps Adventure',
    destination: 'Interlaken, Switzerland',
    image: "https://images.unsplash.com/photo-1671730068364-e3e8e19f9578",
    alt: 'Snow-capped Swiss Alps mountains with green valleys and traditional wooden chalets',
    estimatedPrice: 2899,
    duration: '7 Days',
    savedDate: '2024-02-05'
  },
  {
    id: 'ST003',
    title: 'Santorini Sunset Retreat',
    destination: 'Santorini, Greece',
    image: "https://images.unsplash.com/photo-1618478751717-b2fc9412fd11",
    alt: 'White-washed buildings with blue domes overlooking Aegean Sea at sunset in Santorini',
    estimatedPrice: 1999,
    duration: '6 Days',
    savedDate: '2024-01-28'
  }];


  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-2xl font-black text-foreground flex items-center gap-2">
            <Icon name="BookmarkIcon" size={28} className="text-accent" />
            Saved Trips
          </h3>
          <p className="text-muted-foreground mt-1">Your travel wishlist and saved itineraries</p>
        </div>
        <button className="px-6 py-2.5 gradient-gold-shiny text-primary font-bold rounded-lg shadow-md hover:shadow-lg transition-all duration-200">
          Explore More
        </button>
      </div>

      {/* Saved Trips Grid */}
      {mockSavedTrips.length === 0 ?
      <div className="text-center py-16 bg-surface rounded-xl border border-border">
          <Icon name="BookmarkIcon" size={64} className="mx-auto mb-4 text-muted-foreground opacity-50" />
          <h4 className="text-xl font-black text-foreground mb-2">No Saved Trips Yet</h4>
          <p className="text-muted-foreground mb-6">Start exploring and save your favorite destinations</p>
          <button className="px-6 py-3 bg-primary text-white font-bold rounded-lg hover:bg-secondary transition-all duration-200 shadow-md hover:shadow-lg">
            Browse Destinations
          </button>
        </div> :

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mockSavedTrips.map((trip) =>
        <div
          key={trip.id}
          className="bg-white rounded-xl border border-border shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden group">
          
              <div className="relative h-48 overflow-hidden">
                <AppImage
              src={trip.image}
              alt={trip.alt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
            
                <button className="absolute top-3 right-3 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-colors shadow-lg">
                  <Icon name="BookmarkIcon" size={20} className="text-accent fill-accent" />
                </button>
              </div>
              <div className="p-5">
                <h4 className="text-lg font-black text-foreground mb-2 line-clamp-2">{trip.title}</h4>
                <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
                  <Icon name="MapPinIcon" size={16} className="text-primary" />
                  <span>{trip.destination}</span>
                </div>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="ClockIcon" size={16} />
                      {trip.duration}
                    </span>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-muted-foreground">From</p>
                    <p className="text-xl font-black text-primary">£{trip.estimatedPrice.toLocaleString()}</p>
                  </div>
                </div>
                <div className="flex gap-2">
                  <button className="flex-1 px-4 py-2 bg-primary text-white font-bold rounded-lg hover:bg-secondary transition-all duration-200">
                    Book Now
                  </button>
                  <button className="px-4 py-2 border-2 border-border text-foreground font-bold rounded-lg hover:border-primary hover:text-primary transition-all duration-200">
                    <Icon name="TrashIcon" size={18} />
                  </button>
                </div>
              </div>
            </div>
        )}
        </div>
      }
    </div>);

};

export default SavedTrips;